import { api } from "@/redux/api";

import {
	ListOutreachConfig,
	ListOutreachConfigSchema,
	UpdateListOutreachConfig,
} from "../../pages/List/schema/list-outreach-config.schema";

export interface UpdateListOutreachConfigArgs {
	listId: number;
	body: UpdateListOutreachConfig;
}

/**
 * The per-list outreach configuration (PREC-3687 §6).
 *
 * Its own `injectEndpoints` file because `list.api.ts` is at the file-length ratchet ceiling and
 * may not grow; RTK Query injects into the same base `api` across files
 * (cf. `list-ownership-counts.api.ts`).
 *
 * Components must not read these hooks directly — the payloads are mirrored into
 * `list-outreach.slice.ts`, keyed by list id, and read from its selector (apps/web CLAUDE.md §2).
 */
export const listOutreachApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getListOutreachConfig: builder.query<ListOutreachConfig, number>({
			query: (listId) => ({
				url: `list/${listId}/outreach-config`,
				responseSchema: ListOutreachConfigSchema,
			}),
		}),
		updateListOutreachConfig: builder.mutation<ListOutreachConfig, UpdateListOutreachConfigArgs>({
			query: ({ listId, body }) => ({
				url: `list/${listId}/outreach-config`,
				method: "PATCH",
				body,
				responseSchema: ListOutreachConfigSchema,
			}),
		}),
	}),
});

export const { useGetListOutreachConfigQuery, useUpdateListOutreachConfigMutation } =
	listOutreachApi;
